type Props = {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  skipped: boolean;
};

/**
 * Công tắc watermark — mặc định BẬT (docs/72-growth-viral.md §2, §7.1: watermark là ranh giới
 * miễn phí/trả phí, gỡ được ở gói trả phí).
 *
 * LƯU Ý TRUNG THỰC (quan trọng): backend hiện tại (POST /api/v1/qr/render) CHƯA nhận tham số
 * watermark — `@qrstudio/creative-renderer` đã có sẵn cơ chế watermark đầy đủ
 * (computeWatermarkPlan, an toàn tuyệt đối không đè QR) nhưng route HTTP của apps/api chưa
 * truyền `watermark` vào khi gọi renderer. Vì vậy công tắc này hiện là TUỲ CHỌN CHUẨN BỊ SẴN
 * cho luồng người dùng — chưa có tác dụng thật lên ảnh xuất ra cho tới khi backend nối vào. Giữ
 * nguyên trạng thái BẬT mặc định và copy đúng ý sản phẩm để không phải đổi UI khi backend nối
 * xong, nhưng KHÔNG hiển thị watermark giả trên preview để tránh đánh lừa người dùng.
 */
export default function WatermarkToggle({ enabled, onChange, skipped }: Props) {
  return (
    <div className="watermark-toggle">
      <div className="watermark-toggle-row">
        <label htmlFor="watermark-switch" className="watermark-toggle-label">
          Watermark QR Studio
        </label>
        <button
          id="watermark-switch"
          type="button"
          role="switch"
          aria-checked={enabled}
          className={`switch ${enabled ? "switch-on" : ""}`}
          onClick={() => onChange(!enabled)}
        >
          <span className="switch-knob" />
        </button>
      </div>
      <p className="hint-text small">
        Giúp bạn bè biết bạn tạo mã ở đâu. Tắt watermark có ở gói trả phí.
      </p>
      {!enabled ? (
        <p className="hint-text small watermark-warning">
          Đây là xem trước — khi tải về ở gói miễn phí, ảnh vẫn có watermark.
        </p>
      ) : null}
      {skipped ? (
        <p className="hint-text small">Mẫu này chật nên bỏ watermark.</p>
      ) : null}
    </div>
  );
}
